<template>
  <div>
    <v-menu absolute :close-on-content-click="false" v-model="calendarOpen">
      <template v-slot:activator="{ on, value }">
        <v-label v-if="label">{{ label }}</v-label>
        <v-text-field
          readonly
          persistent-placeholder
          :disabled="disabled"
          :class="{ 'disabled-input': disabled }"
          v-on="on"
          :hide-details="hideDetails"
          :placeholder="'MM/DD/YYYY'"
          :value="formattedDate">
          <template #append>
            <v-icon
              :class="{ 'disabled-input': disabled }"
              :disabled="disabled"
              @click="on.click"
              :color="'body'"
              class="pr-3">
              mdi-calendar-month-outline
            </v-icon>
          </template>
        </v-text-field>
      </template>
      <v-date-picker
        class="date-picker"
        :range="range"
        :no-title="hideTitle"
        @change="updateDate"
        v-model="datePickerValue">
        <div v-if="range">
          <v-btn
            class="uppercase"
            text
            color="primary"
            :disabled="datePickerValue.length !== 2"
            @click="clearDatePicker">
            {{ $t("generic.buttons.clear") }}
          </v-btn>
          <v-btn class="uppercase" text color="primary" @click="calendarOpen = false">
            {{ $t("generic.buttons.cancel") }}
          </v-btn>
          <v-btn class="uppercase" text color="primary" @click="emitRangeValue">
            {{ $t("generic.buttons.ok") }}
          </v-btn>
        </div>
      </v-date-picker>
    </v-menu>
  </div>
</template>

<script>
  import { format } from "date-fns";

  export default {
    name: "VaDatePicker",
    props: {
      label: {
        type: String,
        default: "",
      },
      value: {
        type: [String, Array],
        default: "",
      },
      hideTitle: {
        type: Boolean,
        default: true,
      },
      range: {
        type: Boolean,
        default: false,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      hideDetails: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        calendarOpen: false,
        formattedDate: "",
        datePickerValue: this.value,
      };
    },
    watch: {
      value: {
        handler(val) {
          if (val && !!val.length) {
            if (!this.range) {
              this.formattedDate = format(new Date(val), "MM/dd/yyyy");
              this.datePickerValue = format(new Date(this.value), "yyyy-MM-dd");
            } else {
              this.formattedDate = `${format(new Date(val[0]), "yyyy-MM-dd")} to ${format(
                new Date(val[1]),
                "yyyy-MM-dd",
              )}`;
            }
          }
        },
        immediate: true,
      },
    },
    methods: {
      updateDate(date) {
        if (this.range) return false;
        this.emitValue(date);
        this.calendarOpen = false;
      },
      sortRangeDates(dates) {
        dates.sort((a, b) => new Date(a) - new Date(b));

        return dates;
      },
      emitValue(val) {
        this.$emit("input", val);
        this.$emit("change", val);
      },
      emitRangeValue() {
        if (this.datePickerValue.length === 2) {
          this.$emit("input", this.sortRangeDates(this.datePickerValue));
          this.calendarOpen = false;
        }
      },
      clearDatePicker() {
        this.formattedDate = "";
        this.datePickerValue = [];
        this.$emit("input", []);
        this.calendarOpen = false;
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import "@core/preset/preset/typography/index.scss";
  @import "@core/preset/preset/functions.scss";

  .v-text-field {
    padding-top: 6px;
    cursor: pointer !important;

    &.disabled-input {
      cursor: not-allowed !important;
      &::v-deep {
        input {
          cursor: not-allowed !important;
        }
        .v-input__append-inner {
          cursor: not-allowed !important;
        }
      }
    }

    &::v-deep {
      input {
        cursor: pointer !important;
      }
    }
  }

  // Label
  .v-label {
    color: get-color("subtitle") !important;
    transform: none !important;
    @include text-caption-bold();
  }

  .date-picker {
    padding: 0;

    ::v-deep {
      .v-date-picker-table {
        height: unset;

        .v-btn--outlined {
          color: get-color("secondary-btn") !important;
        }
      }

      .v-picker__actions {
        padding: 5px 10px;
        justify-content: flex-end;

        .v-btn {
          padding: 12px;
          min-width: unset;
        }
      }
    }
  }
</style>
